let devUrl="https://api.zsyykj.top/"

export default {

    /**
     *  @description  配置项目名称
     */
    name: window.Glod.name,

    /**
     * @description 浏览器主要title 
     */
    title: window.Glod.title,

    /**
     * @description token在Cookie中存储的天数，默认1天
     */
    cookieExpires: 1,

    /**
     * @description api请求基础路径
     */
    baseUrl: {
        /**
         * 开发环境
         */
        dev: devUrl,
        /**
         * 生产环境
         */
        pro: window.Glod.baseUrl,
    },

    /**
     * @description 未登录的路由name值，默认为login
     */
    loginName: 'login',

    /**
     * @description 已经登录打开的首页的路由name值，默认为home
     */
    homeName: 'home',
    /**
     * @description 图片上传地址
     */
    imgPath: {
        //开发环境
        dev: devUrl + "admin/upload/local",
        //生产环境
        pro: window.Glod.imgUrl
    },

    /**
     * @description 验证码地址
     */
    checkImage: {
        //开发环境
        dev: devUrl + "admin/captcha/",
        //生产环境
        pro: window.Glod.baseUrl + "admin/captcha/"
    }
}


// WEBPACK FOOTER //
// ./src/config/index.js